import { IStudioLibraryItem } from "@app/shared/models/IStudioLibraryItem";
import { AssetType } from "@app/shared/models/assetType";

export class Media implements IStudioLibraryItem{
  id: number;
  uuid:string;
  name: string;
  type:AssetType;
  src?: string;
  fabricElem:any;
  targetField:string;
  svgSrc:string;
  jsonSrc:string;

  attchmentStatus?: string;
  clientFormat?: string;
  clientRestriction?: string;
  code?: string;
  contentproviderdatecreated?: string;
  contentproviderdatedeleted?: string;
  contentproviderdatemodified?: string;
  contentproviderqcstatus?: string;
  dateArchived?: string;
  dateCreated?:number;
  dateLastModified?:number;
  dateLive?: string;
  dateShoot?: string;
  descr?: string;
  expiryDate?: string;
  exposureDate?: string;
  extratags?: string;
  fullURL?: string;
  imageCodeA?: string;
  imageCodeB?: string;
  isMarketingContent?: string;
  isRestricted?: string;
  mediaRevision?: string;
  mediaSource?: string;
  nodeReference?: string;
  orientation?: string;
  originalDistributionPermit?: string;
  originalFilename?: string;
  originalURL?: string;
  origingraph?: string;
  perspective?: string;
  previewURL?: string;
  searchIndex?: string;
  space?: string;
  studioTrigger?: string;
  style?: string;
  themeTags?: string;
  thumbUrl?: string;
  version?: string;
  isHero:boolean = false;
  selected:boolean = false;
  originOwner?:string;
}

export class MediaSearchCriteria{
  keyword?:string;
  mediaType?:string;
}
export enum SearchType {
  MEDIA = "media",
  DECORATION = "decoration",
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/media.ts